import React from 'react';
import ReactTinyMarkup, { defaultRenderer } from 'react-tiny-markup';
import styled from 'styled-components';

const HTMLtextStyles = styled.span`
  white-space: normal;
  sub {
    vertical-align: bottom;
    font-size: 0.7em;
    position: relative;
    bottom: -0.5rem;
  }
  sup {
    vertical-align: top;
    font-size: 0.7em;
    position: relative;
    top: -0.5rem;
  }
  i {
    font-style: italic;
  }
  b {
    font-weight: bold;
  }
`;

const HTMLtext: React.FC<{
  // We shpuld use the shared-ts HTMLText component, duplicated since styled components has a problem with duplicated classnames
  // https://github.com/styled-components/styled-components/issues/3125 so this is a temporary solution
  children: React.ReactNode;
  additionalTags?: string[];
}> = ({ children, additionalTags = [] }) => {
  const allowedTags = ['sup', 'sub', 'i'].concat(additionalTags);
  return (
    <HTMLtextStyles>
      <ReactTinyMarkup
        renderer={p =>
          (p.tag && allowedTags.includes(p.tag) ? defaultRenderer(p) : p.children)}
      >
        {children}
      </ReactTinyMarkup>
    </HTMLtextStyles>
  );
};

export default HTMLtext;
